var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('span', {
    staticClass: "preview-wrap"
  }, _vm._l(_vm.src, function (image, index) {
    return _c('img', {
      directives: [{
        name: "thumbnail",
        rawName: "v-thumbnail",
        value: image,
        expression: "image"
      }, {
        name: "tryimage",
        rawName: "v-tryimage"
      }],
      key: index,
      staticClass: "preview-image",
      attrs: {
        "data-webp": "false"
      },
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.onClick(image);
        }
      }
    });
  }), 0);
};
var staticRenderFns = [];
export { render, staticRenderFns };